// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1ji7omv-MuiBackdrop-root {
  -webkit-backdrop-filter: blur(10px) !important;
          backdrop-filter: blur(10px) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/shared/backdropOverlay/backdrop.css"],"names":[],"mappings":"AAAA;EACE,8CAAsC;UAAtC,sCAAsC;AACxC","sourcesContent":[".css-1ji7omv-MuiBackdrop-root {\n  backdrop-filter: blur(10px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
